import API from '../../../../helpers/request/api';

const complete = (classId) => {
  const api = new API();
  const query = {
    query: `mutation completeUserPost{
      completeUserPost(input: {
        post_id: ${classId}
      })
      { message }
    }`,
  };
  return api.get(query);
};

const getNext = (currentPostId) => {
  const api = new API();
  const query = {
    query: `{
      next_post(id: ${currentPostId}) {
        slug
      }
    }`,
  };
  return api.get(query);
};

const getPrevious = (currentPostId) => {
  const api = new API();
  const query = {
    query: `{
      previous_post(id: ${currentPostId}) {
        slug
      }
    }`,
  };
  return api.get(query);
};

export default {
  complete,
  getNext,
  getPrevious,
};



// WEBPACK FOOTER //
// ./src/screens/Class/Progress/queries/class.js